define('views/modules/calendar/animated-session/tags/manager/form/custom-tag-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/events/animated-session-events',
    // collections
    'collections/calendar/session/animations',
    // views
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'views/modules/calendar/animated-session/animation/lists/animation-list',
    'views/modules/calendar/animated-session/tags/manager/exercises/tag-exercise-list-item',
    'views/modules/calendar/animated-session/tags/manager/edit/placeholder/tag-exercise-placeholder',
    // templates
    'text!templates/modules/calendar/animated-session/tags/form/custom-tag-form.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    AnimationEvents,
    // collections
    CAnimations,
    // views
    VTextbox,
    VTextarea,
    VExerciseAnimationList,
    VTagExerciseListItem,
    VTagExercisePlaceholder,
    // templates
    TCustomTagForm
) {

    var VCustomTagForm = Backbone.View.extend({

        template: TCustomTagForm,

        // abstracting selectors out of the view logic
        regions: {
            root: '#custom-tag-form',
            name: ".name-input",
            description: ".description-input",
            exercises: ".list-items",
            placeholder: ".placeholder"
        },

        initialize: function() {

            var collection = this.collection = new CAnimations(this.model.getExercises()),
                view = this.view = {
                    form: {
                        name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: this.model }),
                        description: new VTextarea({ label: 'Description', attribute: 'description', labelposition: 'outer', model: this.model, rows: 2, }),
                    },
                    placeholder: new VTagExercisePlaceholder({
                        model: this.model
                    }),
                    exercises: new VExerciseAnimationList({
                        collection: this.collection,
                        async: false,
                        item: VTagExerciseListItem,
                    })
                };

            this.listenTo(this.model, {
                'model:reset sync': this.resetCollection,
                'list:addExercise': this.onAddExerciseAction
            });

            this.listenTo(this.collection, {
                'reset': this.render,
                'animation:remove': this.onAnimationRemove,
                'update': this.onCollectionUpdate,
            });
        },

        initListener: function() {
            this.stopListeningTo(AnimationEvents);

            this.listenTo(AnimationEvents, {
                'exercise:add:animation': this.onAddAnimations,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.initListener();

            // Assign Views
            this.generateZones();
            var view = this.view,
                zone = this.zone,
                model = this.model;

            this.assign(view.form.name, zone.$name)
                .assign(view.form.description, zone.$description)
                .assign(view.placeholder, zone.$placeholder)
                .assign(view.exercises, zone.$exercises);

            zone.$placeholder.toggle(!model.hasExercises());

            return this;
        },

        resetCollection: function() {
            var collection = this.collection;
            collection.reset(this.model.getExercises());
            this.collectionCopy = collection.toJSON({ blacklist: true });
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        onAddAnimations: function(animations) {
            this.collection.add(_.map(animations, function(model) {
                return model.toJSON();
            }));
        },

        onAnimationRemove: function(model) {
            this.collection.remove(model);
        },

        onCollectionUpdate: function(collection) {
            var model = this.model;
            this.zone.$placeholder.toggle(collection.length === 0);
            model.trigger('change');
        },

        onSubmit: function() {
            this.model.set('exercises', this.collection.getModelsId());
        },

        onAddExerciseAction: function() {
            this.trigger('list:addExercise');
        },

    });

    return VCustomTagForm;

});

